import React, { useState,useEffect } from "react";
import TaxInformation from "./tax-information/tax-information";
import TaxCredits from "./tax-credits/tax-credits";
import CapitalGains from "./capital-gains/capital-gains";
import CarryForward from "./carry-forward/carry-forward";
import InflationRates from "./inflation-rates/inflation-rates";
import FormHeader from "../../../styled-components/form-header/form-header";
import RightSidebar from "../../../styled-components/right-sidebar/right-sidebar";
import useActiveTabs from "../../../../hooks/active-tabs";
import TAX_AND_INFLATION_API from "../../../../apis/tax_and_inflation.api";
import Loader from "../../../styled-components/loader/loader";
import { useHistory } from "react-router-dom";
import NewLoader from "../../../styled-components/loader/NewLoader";

function TaxInflationMain() {
  const [activeTabData, setActiveTabData] = useState({
    name: "taxInformation",
    title: "Tax Information",
    unique: "firstName",
    isMulti: false,
    component: TaxInformation,
  });
  const history = useHistory();

  const ActiveComponent = activeTabData.component;

  const [rightToggleClass, setRightToggleClass] = useState(false);
  const [loading, setLoading] = useState(false);
  const [taxInfo,setTaxInfo]= useState(null);

  const handleRightToggleClass = () => {
    setRightToggleClass(!rightToggleClass);
  };

  const taxInflationData = {
    taxInformation: {
      name: "taxInformation",
      title: "Tax Information",
      unique: "firstName",
      isMulti: false,
      component: TaxInformation,
      data: [
        {
          "State Taxation": taxInfo && taxInfo.state ? taxInfo.state : "",
          "Tax Filling Election": taxInfo && taxInfo.taxFillingElection ? taxInfo.taxFillingElection : "",
          Deductions: taxInfo && taxInfo.deductions ? taxInfo.deductions : "",
          "State Tax Effective Rate": taxInfo && taxInfo.stateTaxRate ? taxInfo.stateTaxRate : "",
          "Federal Tax Rate": taxInfo && taxInfo.federalTaxRate ? taxInfo.federalTaxRate : "",
          "Total Tax Rate":  taxInfo && taxInfo.totalTaxRate ? taxInfo.totalTaxRate : "",
          "Federal Collectible Tax Rate": taxInfo && taxInfo.federalCollectibleTaxRate ? taxInfo.federalCollectibleTaxRate : "",
        },
      ],
    },
    taxCredits: {
      name: "taxCredits",
      title: "Tax Credits",
      unique: "Other Tax Credit",
      isMulti: true,
      component: TaxCredits,
      data: [
        {
          "Other Tax Credit": "",
          "Amount Of Credit": "",
          "Whose Credit": "",
        },
        {
          "Other Tax Credit": "",
          "Amount Of Credit": "",
          "Whose Credit": "",
        },
        {
          "Other Tax Credit": "",
          "Amount Of Credit": "",
          "Whose Credit": "",
        },
      ],
    },
    capitalGains: {
      name: "capitalGains",
      title: "Capital Gains",
      unique: "firstName",
      component: CapitalGains,
      isMulti: false,
      data: [
        {
          "Subject to Cap Gains": taxInfo && taxInfo.amountWithdrawnCapGains ? taxInfo.amountWithdrawnCapGains : "",
          "Gains Rate Federal": taxInfo && taxInfo.capGainsRateFederal ? taxInfo.capGainsRateFederal : "",
          "Gains Rate State": taxInfo && taxInfo.capGainsRateState ? taxInfo.capGainsRateState : "",
          "Gains Rate Federal Short Term": taxInfo && taxInfo.capGainsRateFederalShortTerm ? taxInfo.capGainsRateFederalShortTerm : "",
          "Gains Rate State Short Term": taxInfo && taxInfo.capGainsRateStateShortTerm ? taxInfo.capGainsRateStateShortTerm : "",
        },
      ],
    },
    carryForward: {
      name: "carryForward",
      title: "Carry Forward",
      unique: "matric",
      isMulti: false,
      component: CarryForward,
      data: [
        {
          "Total Carry Forward": "",
          "Short Term Carry Forward": "",
          "Long Term Carry Forward": "",
          "Carry Forward Updated": "",
          "Carry Forward Loss Notes": "",
        },
      ],
    },
    inflationRates: {
      name: "inflationRates",
      title: "Inflation Rates",
      unique: "firstName",
      component: InflationRates,
      isMulti: false,
      data: [
        {
          "General Inflation Rate":taxInfo && taxInfo.generalInflationRate ? taxInfo.generalInflationRate : "",
          "Medical Inflation Rate": taxInfo && taxInfo.medicalInflationRate ? taxInfo.medicalInflationRate : "",
          "Education Inflation Rate": taxInfo && taxInfo.educationInflationRate ? taxInfo.educationInflationRate : "",
          "Luxury Inflation Rate": taxInfo && taxInfo.luxuryInflationRate ? taxInfo.luxuryInflationRate : "",
          "Housing Inflation Rate": taxInfo && taxInfo.housingInflationRate ? taxInfo.housingInflationRate : "",
        },
      ],
    },
  };

  const [allFormsData, setAllFormsData] = useState(taxInflationData);

  const tabsArray = Object.values(taxInflationData);
  const [activeTabsArray, setActiveTabsArray] = useState(["taxInformation"]);

  //  pass all tabs array and selected tab name to useActiveTabs hook
  //  useActiveTabs Hook will return all previous tabs with selected tab
  const handleActiveTabsArray = (name) => {
    const activeTabs = useActiveTabs(tabsArray, name);

    setActiveTabsArray([...activeTabs]);
  };

  const nextForm = (nextFormData) => {
    setActiveTabData(nextFormData);

    const activeTabs = useActiveTabs(tabsArray, nextFormData.name);

    setActiveTabsArray([...activeTabs]);
  };
  const preForm = (previousFormData) => {
    setActiveTabData(previousFormData);

    const activeTabs = useActiveTabs(tabsArray, previousFormData.name);

    setActiveTabsArray([...activeTabs]);
  };

  // pass all form data of one component and update in main object (allFormsData)
  const handleTaxInflationObject = async (pageData) => {
    // setAllFormsData((formData) => {
    //   return {
    //     ...formData,
    //     [activeTabData.name]: {
    //       ...formData[activeTabData.name],
    //       [activeTabData.name]: activeTabData.isMulti
    //         ? {
    //             ...formData[activeTabData.name][activeTabData.name],
    //             [pageData[activeTabData.unique]]: pageData,
    //           }
    //         : { [pageData[activeTabData.unique]]: pageData },
    //     },
    //   };
    // });

    setAllFormsData((formData) => {
      return {
        ...formData,
        [activeTabData.name]: {
          ...formData[activeTabData.name],
          data: activeTabData.isMulti ? pageData : [pageData],
        },
      };
    });
    console.log("allFormsData", allFormsData, pageData);

    if (activeTabData.name === "inflationRates") {
      let payload = {
        state:
          allFormsData &&
          allFormsData.taxInformation &&
          allFormsData.taxInformation.data[0]["State Taxation"],
        taxFillingElection:
          allFormsData &&
          allFormsData.taxInformation &&
          allFormsData.taxInformation.data[0]["Tax Filling Election"],
        deductions:
          allFormsData &&
          allFormsData.taxInformation &&
          allFormsData.taxInformation.data[0]["Deductions"],
        stateTaxRate:
          allFormsData &&
          allFormsData.taxInformation &&
          +allFormsData.taxInformation.data[0]["State Tax Effective Rate"],
        federalTaxRate:
          allFormsData &&
          allFormsData.taxInformation &&
          +allFormsData.taxInformation.data[0]["Federal Tax Rate"],
        totalTaxRate: +allFormsData.taxInformation.data[0]["Total Tax Rate"],
        federalCollectibleTaxRate:
          allFormsData &&
          allFormsData.taxInformation &&
          +allFormsData.taxInformation.data[0]["Federal Collectible Tax Rate"],
        amountWithdrawnCapGains:
          allFormsData &&
          allFormsData.capitalGains &&
          +allFormsData.capitalGains.data["Subject To Cap Gains"],
        capGainsRateFederal:
          allFormsData &&
          allFormsData.capitalGains &&
          +allFormsData.capitalGains.data["Gains Rate Federal"],
        capGainsRateState:
          allFormsData &&
          allFormsData.capitalGains &&
          +allFormsData.capitalGains.data["Gains Rate State"],

        capGainsRateFederalShortTerm:
          allFormsData &&
          allFormsData.capitalGains &&
          +allFormsData.capitalGains.data["Gains Rate Federal Short Term"],

        capGainsRateStateShortTerm:
          allFormsData &&
          allFormsData.capitalGains &&
          +allFormsData.capitalGains.data["Gains Rate State Short Term"],

        generalInflationRate: pageData && +pageData["General Inflation Rate"],
        medicalInflationRate: pageData && +pageData["Medical Inflation Rate"],
        educationInflationRate:
          pageData && +pageData["Education Inflation Rate"],
        luxuryInflationRate: pageData && +pageData["Luxury Inflation Rate"],
        housingInflationRate: pageData && +pageData["Housing Infaltion Rate"],
      };

      try {
        setLoading(true);
        if(taxInfo && taxInfo){
          payload.id=taxInfo && taxInfo.id;
          let res = await TAX_AND_INFLATION_API.updateTaxInflationDetails(payload);
          if (res && res.status === 200) {
            history.push("/tax_inflation");
          }
        }
        else{
          let res = await TAX_AND_INFLATION_API.saveTaxInflationDetails(payload);
          if (res && res.status === 200) {
            history.push("/tax_inflation");
          }
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.log("error while creating tax credit", error);
      }
    }
  };
  const getTaxInflationDetails = async () => {
    try {
      setLoading(true);
      let data = await TAX_AND_INFLATION_API.fetchTaxInflationDetails();
      if (data && data.data) {
        //inflation details
        console.log("response==>", data.data);
        if(data.data[0]){
          setTaxInfo(data.data[0])
        }
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while fetching Tax Inflation Details", error);
    }
  };
  useEffect(() => {
    getTaxInflationDetails();
  }, []);
  return (
    <div style={{ margin: "1rem",position:"relative" }}>
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "1rem",
          paddingBottom: "40px",
        }}
        className={
          rightToggleClass
            ? "form-page-container-wrap right-side--opend"
            : "form-page-container-wrap right-side--collapsed"
        }
      >
        <div style={{ paddingRight: rightToggleClass ? "400px" : "0px" }}>
          <FormHeader
            headerData={taxInflationData}
            activeTabData={activeTabData}
            setActiveTabData={setActiveTabData}
            activeTabsArray={activeTabsArray}
            handleActiveTabsArray={handleActiveTabsArray}
            handleTabClick={(tabName) => {
              const selectedTab = tabsArray && tabsArray.find((tab) => tab.name === tabName);
              console.log("tabName",tabName,selectedTab,tabsArray)
              if (selectedTab) {
                setActiveTabData(selectedTab);
                handleActiveTabsArray(tabName);
              }
            }}
          />
        </div>
        <div style={{ paddingRight: rightToggleClass ? "400px" : "0px" }}>
          <ActiveComponent
            handleTaxInflationObject={handleTaxInflationObject}
            data={allFormsData}
            taxInfo={taxInfo && taxInfo}
            nextForm={nextForm}
            preForm={preForm}
            activeTabData={activeTabData}
          />
        </div>
        {/* <div className="form-page--right-side custom">
          <span
            className="right-side-collapse-icon"
            onClick={handleRightToggleClass}>
            <i className="fe-menu"></i>
          </span>
      
        </div> */}
      </div>
      <NewLoader isLoading={loading} />
    </div>
  );
}

export default TaxInflationMain;
